import React, { useEffect, useState } from "react";
import Main from "../pages/Main";
import { exportTable } from "../utils/downloadExcel";
import { fetchSettalmentsLists } from "../api/settalmentApi";
import { autoDateFormat } from "../utils/autoDateFormate";
import { formatAmount } from "../utils/formatAmount";
import { useWallet } from "../context/walletContext";
import { useSelector } from "react-redux";

import { useNotify } from "../context/NotifyContext";
import WalletHistoryBar from "../components/WalletHistoryBar";
import { useTxnDocActions } from "../hooks/useTxnDocActions";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  CopyText,
  AppBreadcrumbs,
  RowActions,
  StatusBadge,
  useListingState,
  TXN_STATUS_OPTIONS,
} from "../components/listing";
import { SOCKET_EVENTS } from "../socket/socketEvents";
import useSocketEvent from "../socket/useSocketEvent";
import { useCallback } from "react";

const SettlementHistory = () => {
  const { walletAmt } = useWallet();
  const { notify } = useNotify();
  const { userInfo } = useSelector((state) => state?.auth);
  const listing = useListingState({
    sortBy: "date",
    sortDir: "desc",
  });
  const [settlementList, setSettalmentsList] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("settlement");

  const fetch_settalmentsList = async () => {
    try {
      const result = await fetchSettalmentsLists(listing.query);
      if (result?.success) {
        setSettalmentsList(result.data.withdrawAmountSettalment || []);
        setTotalPages(result.data.pagination?.totalPages || 1);
        setTotalCount(result.data.pagination?.total || 0);
        setTotalCharges(result?.data?.totalCharges || 0);
        setTotalAmount(result?.data?.totalAmount || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {
      notify("Server Error", "error");
    }
  };

  useEffect(() => {
    fetch_settalmentsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listing.page,
    listing.limit,
    listing.startDate,
    listing.endDate,
    listing.debouncedSearch,
    listing.sortBy,
    listing.sortDir,
    listing.status,
  ]);

  const handleSettlementUpdate = useCallback(
  (payload) => {
    if (!payload?.settlementId) return;

    setSettalmentsList((prev) =>
      prev.map((item) =>
        String(item?._id) ===
        String(payload.settlementId)
          ? {
              ...item,
              transactionStatus:
                payload.transactionStatus ??
                item.transactionStatus,
              utrNumber:
                payload.utrNumber ??
                item.utrNumber,
              remark:
                payload.remark ??
                item.remark,
            }
          : item
      )
    );
  },
  []
);

useSocketEvent(
  SOCKET_EVENTS.SETTLEMENT_UPDATED,
  handleSettlementUpdate
);

  return (
    <Main showRightPanel={false}>
      <div className="mt-4">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "Other Options" },
            { label: "Settlement History" },
          ]}
        />

        <WalletHistoryBar to="/add-money-ledger">
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={`${userInfo?.logo}`}
              alt="profile"
              className="h-10 w-10 rounded-ds object-cover shrink-0"
            />
            <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap min-w-0">
              <p className="text-[15px] font-semibold text-[var(--text-dark)]">
                {userInfo?.name || "GUEST"}
              </p>
              <p className="hidden md:block text-[18px] font-semibold text-[var(--text-muted)]">|</p>
              <p className="text-[12px] md:text-[15px] font-semibold text-[var(--text-muted)]">
                ID: {userInfo?.userName}
              </p>
            </div>
          </div>
          <div className="text-right font-semibold text-[10px] md:text-[15px] leading-tight w-full md:w-auto text-[var(--text-dark)]">
            ADD MONEY WALLET BALANCE :
            <span className="font-bold ml-1 text-[14px] md:text-[16px] text-[var(--success-color)]">
              ₹ {formatAmount(walletAmt?.addMoney?.balance)}
            </span>
          </div>
        </WalletHistoryBar>

        <div className="ds-card text-sm">
          <ListingFilters
            onClear={listing.clearFilters}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search"
            status={listing.status}
            onStatus={listing.setStatus}
            statusOptions={TXN_STATUS_OPTIONS}
            showApply
            onApply={fetch_settalmentsList}
            applyLabel="Load Records"
            onExport={() =>
              exportTable(
                "settlement-history",
                [
                  { label: "TRANS DATE", value: (r) => (r?.createdAt ? autoDateFormat(r.createdAt) : "") },
                  { label: "AMOUNT", key: "amount" },
                  { label: "WITH CHARGE", key: "charges" },
                  { label: "ACCOUNT HOLDER NAME", key: "accountHolderName" },
     { label: "ACCOUNT NUMBER", key: "accountNumber" },
{ label: "UPI ID", key: "upiId" },
{ label: "IFSC CODE", key: "ifsc" },
                  { label: "BANK NAME", value: (r) => r?.bankAccountId?.bankName ?? "" },
                  { label: "UTR NUMBER", value: (r) => r?.utrNumber ?? r?.rawResponse?.utrNumber ?? "" },
                  { label: "MERCHANT", value: (r) => r?.userId?.name ?? "" },
                  { label: "PLATFORM", key: "platform" },
                  { label: "STATUS", key: "transactionStatus" },
                ],
                settlementList,
                notify
              )
            }
          />

          <div className="ds-table-wrap ds-scroll">
         <table className="ds-table ds-table-listing min-w-[1200px]">
              <thead>
              <tr>
  <SortableTh
    label="TRANS. DATE"
    sortKey="date"
    activeKey={listing.sortBy}
    direction={listing.sortDir}
    onSort={listing.toggleSort}
  />

  <SortableTh
    label="STATUS"
    sortKey="status"
    activeKey={listing.sortBy}
    direction={listing.sortDir}
    onSort={listing.toggleSort}
  />

  <SortableTh
    label="AMOUNT"
    sortKey="amount"
    activeKey={listing.sortBy}
    direction={listing.sortDir}
    onSort={listing.toggleSort}
  />

  <th>WITH CHARGE</th>
  <th>ACCOUNT HOLDER NAME</th>
  <th>ACCOUNT NUMBER</th>
  <th>UPI ID</th>
  <th>IFSC CODE</th>
  <th>BANK NAME</th>
  <th>UTR NUMBER</th>
  <th>MERCHANT CODE-NAME</th>
  <th>PLATFORM</th>
  <th className="ds-th-actions">ACTIONS</th>
</tr>
              </thead>
              <tbody>
                {settlementList?.length === 0 ? (
                  <tr>
                    <td colSpan="13" className="text-center text-[var(--text-muted)]">
                      NO DATA AVAILABLE IN TABLE
                    </td>
                  </tr>
                ) : (
                  settlementList?.map((row, index) => (
                 <tr key={row?._id || index}>
  <td>
    {row?.createdAt
      ? autoDateFormat(row.createdAt)
      : "--"}
  </td>

  {/* STATUS - SECOND COLUMN */}
  <td>
    <StatusBadge status={row?.transactionStatus} />
  </td>

  <td className="ds-td-amount">
    ₹ {row?.amount?.toFixed(2) ?? "--"}
  </td>

  <td>
    ₹ {row?.charges?.toFixed(2) ?? "--"}
  </td>

  <td>
    {row?.accountHolderName ?? "--"}
  </td>

  <td>
    <CopyText
      value={row?.accountNumber}
      label="Account Number"
    />
  </td>

  {/* UPI */}
  <td>
    <CopyText
      value={row?.upiId}
      label="UPI ID"
    />
  </td>

  <td>
    {row?.ifsc ?? "--"}
  </td>

  <td>
    {row?.bankAccountId?.bankName ?? "--"}
  </td>

  <td>
    <CopyText
      value={
        row?.utrNumber ??
        row?.rawResponse?.utrNumber
      }
      label="UTR"
    />
  </td>

  <td>
    {row?.userId?.userName ?? "--"} -{" "}
    {row?.userId?.name ?? "--"}
  </td>

  <td>
    {row?.platform ?? "--"}
  </td>

  <td>
    <RowActions
      onView={() => viewTxn(row)}
      onPdf={() => pdfTxn(row)}
      onPrint={() => printTxn(row)}
    />
  </td>
</tr>
                  ))
                )}
              </tbody>
              <tfoot>
            <tr className="ds-table-total">
  <td className="ds-table-total__label">
    TOTAL TRANSFER
  </td>

  <td></td>

  <td className="ds-table-total__value">
    ₹ {formatAmount(totalAmount)}
  </td>

  <td className="ds-td-amount">
    ₹ {formatAmount(totalCharges)}
  </td>

  <td colSpan="9"></td>
</tr>
              </tfoot>
            </table>
          </div>

          <ListingPagination
            page={listing.page}
            limit={listing.limit}
            total={totalCount || settlementList.length}
            totalPages={totalPages}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
          />
        </div>
      </div>
    </Main>
  );
};

export default SettlementHistory;
